import { ApiEntity } from "../../Api/api.model";
import { type, string, array } from "superstruct";
import { validateStruct } from "../../../utils/validate";
import { coerceTags } from "../../serviceUtils";
import { MediaAsset, MediaAssetStruct } from "../../../utils/assets";

const ActionStruct = type({
  id: string(),
  tags: array(string()),
  name:string(),
  created_at: string(),
  updated_at: string(),
  coverImg: MediaAssetStruct,
  title: string(),
  content: string(),
});
export interface GameAction {
  id: string;
  tags: Array<string>;
  coverImg: MediaAsset;
  order?: number;
  title:string;
  content:string;
}
export class GameActionEntity extends ApiEntity<Array<GameAction>> {
  constructor(){
    super("actions");
  }
  validate(rawData: Array<any>):Array<GameAction> {
    return rawData.map((rawItem) => validateStruct<GameAction>(rawItem, ActionStruct,this.endPoint,[{field:'tags',transform:coerceTags}, {field:'id',transform:(id:number) => id.toString() }]));
  }
}
